export default __webpack_public_path__ + "static/media/cassie.e67952a4.png";